// RichStateKit — shaped loading skeletons that mirror the real bento (so rich
// surfaces don't "collapse to a list" while loading) + branded empty states
// that always carry an icon/eyebrow/description/action, including positive
// "cleared queue" variants in sage.

import './redesign.css';

export function KpiBandSkeleton({ count = 4 }) {
  return (
    <div className="skeleton-kpi-band" style={{ '--kpi-cols': count }} aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton skeleton-kpi" />
      ))}
    </div>
  );
}

export function ChartSkeleton({ height = 280 }) {
  return <div className="skeleton skeleton-chart" style={{ height }} aria-hidden="true" />;
}

export function TableSkeleton({ rows = 6 }) {
  return (
    <div className="skeleton-table" aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton skeleton-line" />
      ))}
    </div>
  );
}

export function BrandedEmptyState({ icon, eyebrow, title, description, action, tone = 'slate' }) {
  return (
    <div className={`empty-state branded-empty tone-${tone}`}>
      {icon ? (
        <div className="branded-empty__icon" aria-hidden="true">
          {icon}
        </div>
      ) : null}
      {eyebrow ? <span className="eyebrow">{eyebrow}</span> : null}
      {title ? <h3>{title}</h3> : null}
      {description ? <p className="muted">{description}</p> : null}
      {action ? <div className="branded-empty__action">{action}</div> : null}
    </div>
  );
}
